export default __webpack_public_path__ + "static/thumbnail-ebcc4b311c77088c2b35b9ed0c820b99.png";